import React from 'react';
import PropTypes from 'prop-types';

function Sidebar({ activeItem, onNavigate }) {
	const menuItems = [
		{ id: 'dashboard', label: 'Dashboard', icon: 'dashboard' },
		{ id: 'monitors', label: 'Monitors', icon: 'monitor' },
		{ id: 'incidents', label: 'Incidents', icon: 'report_problem' },
		{ id: 'status-pages', label: 'Status Pages', icon: 'check_circle' },
		{ id: 'teams', label: 'Teams', icon: 'group' },
		{ id: 'settings', label: 'Settings', icon: 'settings' }
	];

	const handleLogoClick = () => {
		if (onNavigate) {
			onNavigate('dashboard');
		}
	};

	return (
		<aside className="sidebar" aria-label="Main navigation">
			<button 
				className="sidebar-logo" 
				onClick={handleLogoClick}
				aria-label="Go to dashboard"
				type="button"
				style={{ 
					background: 'none', 
					border: 'none', 
					cursor: 'pointer',
					width: '100%',
					textAlign: 'left'
				}}
			>
				<div className="logo-icon" aria-hidden="true">U</div>
				<span className="logo-text">Neutrino</span>
			</button>
			<nav className="sidebar-nav" role="navigation" aria-label="Primary navigation">
				{menuItems.map(item => (
					<button
						key={item.id}
						className={`nav-item ${activeItem === item.id ? 'active' : ''}`}
						onClick={() => onNavigate && onNavigate(item.id)}
						aria-label={`Navigate to ${item.label}`}
						aria-current={activeItem === item.id ? 'page' : undefined}
					>
						<span className="nav-icon material-icons" aria-hidden="true">{item.icon}</span>
						<span className="nav-label">{item.label}</span>
					</button>
				))}
			</nav>
			<div className="sidebar-footer">
				<a 
					href="https://neutrinodesign.com" 
					target="_blank" 
					rel="noopener noreferrer"
					className="sidebar-footer-link"
				>
					NeutrinoDesign.com
				</a>
			</div>
		</aside>
	);
}

Sidebar.propTypes = {
	activeItem: PropTypes.string.isRequired,
	onNavigate: PropTypes.func,
};

export default React.memo(Sidebar);

